import React, { useContext, type MouseEventHandler } from 'react';
import { IngestFile } from '@/redux/slices/slice_types';
import { type ButtonProps } from '@mui/material';
import { ConfigContext } from '@/contextAPI/configContext';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import AnimatedHaloButton from '@/components/_common/AnimatedHaloButton';
import ConditionalTooltip from '@/components/_common/ConditionalTooltip/ConditionalTooltip';

interface Props {
  fileType: IngestFile['file_type'];
  color: ButtonProps['color'];
  onClick: MouseEventHandler;
}

const ReadyToRegisterButton: React.FC<Props> = ({ fileType, color, onClick }) => {
  const isFileIngestButtonDisabledForImages: boolean | undefined = useContext(ConfigContext).ingestManagementConfig.disableReadyToRegisterForImages;
  const isFileIngestButtonDisabled = isFileIngestButtonDisabledForImages && fileType === 'image';

  const button = (
    <AnimatedHaloButton
      color={color}
      disabled={isFileIngestButtonDisabled}
      variant="outlined"
      startIcon={<PolarisIcon icon="link" height={18} />}
      onClick={onClick}
    >
      Ready to Register
    </AnimatedHaloButton>
  );

  if (!isFileIngestButtonDisabled) {
    return button;
  }

  return (
    <ConditionalTooltip show title={'Not available for images'}>
      <div>{button}</div>
    </ConditionalTooltip>
  );
};

export default ReadyToRegisterButton;
